/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DomainMinimal
 */
export interface DomainMinimal {
    /**
     * Unique identifier of the domain
     * @type {string}
     * @memberof DomainMinimal
     */
    id: string;
    /**
     * Domain name or URL
     * @type {string}
     * @memberof DomainMinimal
     */
    name: string;
}

/**
 * Check if a given object implements the DomainMinimal interface.
 */
export function instanceOfDomainMinimal(value: object): value is DomainMinimal {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function DomainMinimalFromJSON(json: any): DomainMinimal {
    return DomainMinimalFromJSONTyped(json, false);
}

export function DomainMinimalFromJSONTyped(json: any, ignoreDiscriminator: boolean): DomainMinimal {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function DomainMinimalToJSON(json: any): DomainMinimal {
    return DomainMinimalToJSONTyped(json, false);
}

export function DomainMinimalToJSONTyped(value?: DomainMinimal | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

